import React, { useEffect, useState } from 'react'
import InputTextUC from '../../../../components/InputTextUC'
import { SearchOutlined } from '@ant-design/icons';
import SelectUC from '../../../../components/selectUC';
import ButtonUC from '../../../../components/buttonUC';
import { Col, Image, message, Row, Typography } from 'antd';
import useHome from '../../context/useHome';
import TreeSelectUC from '../../../../components/treeSelect';
import * as _ from 'lodash'
import CheckBoxUC from '../../../../components/Form/CheckBoxUC';
import AiIcon from '../../../../assets/images/ai/ai-generator-white.png'
import { getJobRecommendAIStorage, getUserStorage, setJobRecommendAIStorage } from '../../../../utils/localStorage';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { isAILoadingState, isGetJobRecommendAIState, isUpdateUserAfterSaveState } from '../../../../recoil/states/default';
import axiosRc from '../../../../config/axios-rc'
import styled from 'styled-components';

const FlexTagA = styled.div`    
    .ant-checkbox {
        width: 30px !important;
        height: 22px !important;  
    }
    .ant-checkbox-inner {
        width: 24px !important;
        height: 24px !important;
    }
    .ant-checkbox-inner {
        margin-left: 0px !important;
    }
    `;

const FormSearch = (props) => {
    const { resetForm, form } = props
    const { ddlBu, ddlOrgUnit, ddlPositionGroup, ddlPositionCareer, ddlProvince } = useHome()
    const { Text } = Typography
    const [useAdvSearch, setUseAdvSearch] = useState(false)
    const [ddlOrgUnitFilter, setDDLOrgUnitFilter] = useState(ddlOrgUnit)
    const isUpdateUser = useRecoilValue(isUpdateUserAfterSaveState)
    const setIsLoadingAI = useSetRecoilState(isAILoadingState)
    const [isGetJobRecommendAI, setIsGetJobRecommendAI] = useRecoilState(isGetJobRecommendAIState)
    const [loggedIn, setLoggedIn] = useState(false)

    useEffect(() => {
        const user = getUserStorage()
        setLoggedIn(user?.isLoggedIn === true)
    }, [isUpdateUser])

    useEffect(() => {
        if (ddlOrgUnit) {
            handleChangeBu('all')
        }
    }, [ddlOrgUnit])

    const toggleAdvSearch = () => {
        setUseAdvSearch(!useAdvSearch)
    }

    const isMobile = window.innerWidth <= 768

    const handleChangeBu = (value) => {
        if (value !== 'all') {
            form.setFieldsValue({
                orgUnit: ['all']
            });
            if (ddlOrgUnit) {
                const children = ddlOrgUnit[0].children?.filter(item =>
                    item.fieldFilter.slice(0, 2) === form.getFieldValue('bu') ||
                    form.getFieldValue('bu') === 'all'
                );
                filterChildren(children)
            }
        } else {
            const children = _.cloneDeep(ddlOrgUnit[0]?.children)
            filterChildren(children)
        }
    }

    const filterChildren = (children) => {
        let _ddl = [{
            title: 'ทั้งหมด',
            value: 'all',
            key: 'all',
            children: []
        }];
        if (children && children.length > 0) {
            // Create a map to track unique titles
            const uniqueTitles = [];

            children.forEach(child => {
                if (!uniqueTitles.includes(child.title)) {
                    uniqueTitles.push(child.title);
                    _ddl[0].children.push(child);
                }
            });
        }
        setDDLOrgUnitFilter(_ddl);
    }


    const onResetForm = () => {
        handleChangeBu('all')
        resetForm()
    }

    const handleClickJobByAI = async () => {
        try {
            setIsLoadingAI(true)
            const jobRecommend = getJobRecommendAIStorage()
            if (!jobRecommend) {
                const user = getUserStorage()
                const { data } = await axiosRc.get(`/jobList/get_job_recommend_ai/${user?.id}`);
                if (data?.jobListJobReqList?.length > 0) {
                    setJobRecommendAIStorage(data?.jobListJobReqList)
                } else {
                    message.info('ไม่พบตำแหน่งงานที่แนะนำด้วย AI')
                }
            }
            setIsGetJobRecommendAI(!isGetJobRecommendAI)
        } catch (error) {
            console.log('handleClickJobByAI error =>', error)
        } finally {
            setIsLoadingAI(false)
        }
    }

    return (
        <div>
            <Row className={`w-full input-search`}>
                <Col span={24} className='w-full org px-2 mb-3'>
                    <InputTextUC
                        placeholder='ค้นหา'
                        name={'searchKeyword'}
                        suffix={<SearchOutlined />}
                    />
                </Col>
            </Row>
            {
                isMobile && <Row className='w-full mb-3'>
                    <Col span={24} className='advSrearch px-2 mb-3 text-right '>
                        <Text className='color-info underline cursor-pointer' onClick={toggleAdvSearch}>
                            {useAdvSearch ? 'ปิดการค้นหาขั้นสูง' : 'การค้นหาขั้นสูง'}
                        </Text>
                    </Col>
                </Row>
            }
            {
                (!isMobile || (isMobile && useAdvSearch)) &&
                <>
                    <Row className={`w-full input-search`}>
                        <Col xs={24} md={isMobile ? 24 : 12} className='org px-2 mb-3 w-full'>
                            <SelectUC
                                label={'หน่วยงาน'}
                                placeholder='หน่วยงาน'
                                showSearch={true}
                                name={'bu'}
                                optionValues={ddlBu}
                                onChange={handleChangeBu}
                            />
                        </Col>
                        <Col xs={24} md={isMobile ? 24 : 12} className={`${isMobile ? 'mt-4 ' : ''} orgUnit px-2 w-full`}>
                            <TreeSelectUC
                                label={'ฝ่าย'}
                                treeData={ddlOrgUnitFilter}
                                name="orgUnit"
                                value={['all']}
                                placeholder='ฝ่าย'
                                allowClear
                            />
                        </Col>
                        {/* <Col xs={24} md={8} className='employmentType px-2 w-full'>
                            <TreeSelectUC
                                label={'ประเภทการจ้าง'}
                                treeData={ddlEmploymentType}
                                name="employmentType"
                                value={['all']}
                                placeholder='ประเภทการจ้าง'
                                allowClear
                            />
                        </Col> */}
                    </Row>
                    <FlexTagA>
                        <Row className={`w-full input-search`}>
                            <Col xs={24} md={8} className='org px-2 mb-3 w-full' style={{ display: 'none' }}>
                                <TreeSelectUC
                                    label={'กลุ่มวิชาชีพ'}
                                    treeData={ddlPositionGroup}
                                    name="positionGroup"
                                    value={['all']}
                                    placeholder='กลุ่มวิชาชีพ'
                                    allowClear
                                />
                            </Col>
                            <Col span={isMobile ? 24 : 12} className='orgUnit px-2 mb-3 w-full'>
                                <TreeSelectUC
                                    label={'ตำแหน่งตามสายงาน'}
                                    treeData={ddlPositionCareer}
                                    name="positionCareer"
                                    value={['all']}
                                    placeholder='ตำแหน่งตามสายงาน'
                                    allowClear
                                />
                            </Col>
                            <Col xs={24} md={8} className='orgUnit px-2 mb-3 w-full' style={{ display: 'none' }}>
                                <TreeSelectUC
                                    label={'จังหวัด'}
                                    treeData={ddlProvince}
                                    name="province"
                                    value={['all']}
                                    placeholder='จังหวัด'
                                    allowClear
                                />
                            </Col>
                            <Col xs={24} md={12} >
                                <Col span={24} className='px-2'>ประเภทบุคลากร</Col>
                                <Col span={24} className={`${isMobile ? 'mb-4 justify-between' : 'flex mt-3'}`}>
                                    <Col span={isMobile ? 24 : 12} className='px-2'>
                                        <CheckBoxUC
                                            isShowHead={false}
                                            label={'บุคลากรประจำ'}
                                            name={'isAnnual'} />
                                    </Col>
                                    <Col span={isMobile ? 24 : 12} className={`${isMobile ? 'pl-2' : 'pl-2'}`}>
                                        <CheckBoxUC
                                            isShowHead={false}
                                            label={'บุคลากรสัญญาจ้าง'}
                                            name={'isNotAnnual'} />
                                    </Col>
                                </Col>
                            </Col>
                        </Row>
                    </FlexTagA>
                    <FlexTagA>
                        <Row className={`${isMobile ? 'mb-4' : ''}`}>
                            {/* <Col span={isMobile ? 24 : 12}>
                                <Row>
                                    <Col span={24} className='px-2 pb-2'>
                                        <span>ประเภทบุคลากร</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={isMobile ? 24 : 6} className='px-2'>
                                        <CheckBoxUC
                                            isShowHead={false}
                                            label={'บุคลากรประจำ'}
                                            name={'isAnnual'} />
                                    </Col>
                                    <Col span={isMobile ? 24 : 12} className='pl-2'>
                                        <CheckBoxUC
                                            isShowHead={false}
                                            label={'บุคลากรสัญญาจ้าง'}
                                            name={'isNotAnnual'} />
                                    </Col>
                                </Row>
                            </Col> */}
                            <Col span={isMobile ? 24 : 12} className={`${isMobile ? 'pt-2' : ''}`}>
                                <Row>
                                    <Col span={24} className='px-2 pb-2'>
                                        <span>ประเภทของประกาศรับสมัคร</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={isMobile ? 24 : 12} className='px-2'>
                                        <CheckBoxUC
                                            isShowHead={false}
                                            label={'ตำแหน่งที่อยู่ระหว่างการเปิดรับสมัคร'}
                                            name={'isGeneral'} />
                                    </Col>
                                    <Col span={isMobile ? 24 : 12} className='pl-2 '>
                                        <CheckBoxUC
                                            isShowHead={false}
                                            label={'ตำแหน่งที่เปิดให้ฝากใบสมัคร'}
                                            name={'isNotGeneral'} />
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                    </FlexTagA>
                    {/* <Row className={`flex ${isMobile ? 'mb-4 justify-between' : ''}`}>
                        <Col span={isMobile ? 12 : 4} className='px-2'>
                            <CheckBoxUC
                                isShowHead={false}
                                label={'บุคลากรประจำ'}
                                name={'isAnnual'} />
                        </Col>
                        <Col span={isMobile ? 12 : 4} className='pl-2 text-right'>
                            <CheckBoxUC
                                isShowHead={false}
                                label={'บุคลากรสัญญาจ้าง'}
                                name={'isNotAnnual'} />
                        </Col>
                    </Row> */}
                </>
            }

            <Row className='w-full text-center justify-center'>
                <Col span={isMobile ? 12 : 4} className='px-2 text-right'>
                    <ButtonUC className='btn-clear w-full' onClick={onResetForm}>ล้างค่า</ButtonUC>
                </Col>
                <Col span={isMobile ? 12 : 4} className='px-2 text-left'>
                    <ButtonUC className='btn-custom w-full' htmlType='submit'>ค้นหา</ButtonUC>
                </Col>
              
                {/* //FB25 : เว็บไซต์ > ซ่อนปุ่มแนะนำตำแหน่งงานด้วย AI
                // {loggedIn &&  
                    <Col className={`px-2 text-left ${isMobile ? 'mt-3 ant-col-24' : ''}`}>
                        <ButtonUC className='btn-ai w-full px-4'
                            htmlType='button'
                            onClick={handleClickJobByAI}
                            iconPosition={'end'}
                            icon={<Image
                                className="image-ai"
                                style={{ objectFit: "cover" }}
                                width={20}
                                height={20}
                                preview={false}
                                src={AiIcon}
                            />}>แนะนำตำแหน่งงานด้วย AI</ButtonUC>
                    </Col>
                } */}
            </Row>
        </div >
    )
}

export default FormSearch